import { CartLinesUpdateEvent } from '@shopify/events';

const KEY = 'mollo_cart_deadline';
class MolloCartTimer extends HTMLElement {
  connectedCallback() {
    const mins = +this.dataset.minutes || 12, total = mins * 60000;
    let dl = 0;
    try { dl = +localStorage.getItem(KEY) || 0; } catch (e) {}
    const now = Date.now();
    if (!dl || dl <= now) { dl = now + total; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    const t = this.querySelector('[data-time]'), bar = this.querySelector('[data-bar]');
    const tick = () => {
      const left = dl - Date.now();
      if (left <= 0) { dl = Date.now() + total; try { localStorage.setItem(KEY, dl); } catch (e) {} return; }
      this.hidden = false;
      const s = Math.ceil(left / 1000);
      t.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      if (bar) bar.style.transform = 'scaleX(' + (left / total) + ')';
      this.classList.toggle('is-low', left < 120000);
    };
    tick();
    this._i = setInterval(tick, 1000);
  }
  disconnectedCallback() { clearInterval(this._i); }
}
if (!customElements.get('mollo-cart-timer')) customElements.define('mollo-cart-timer', MolloCartTimer);

class MolloCartUpsell extends HTMLElement {
  connectedCallback() { this.addEventListener('click', this.onClick); }
  disconnectedCallback() { this.removeEventListener('click', this.onClick); }
  onClick = async (e) => {
    const btn = e.target.closest('[data-add]');
    if (!btn || btn.disabled) return;
    const card = btn.closest('.mo-cu__card');
    const id = card.querySelector('[data-v]').value;
    btn.disabled = true; btn.classList.add('is-busy');
    const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const d = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity: 1 }], promise: d.promise }));
    try {
      const r = await fetch((window.Theme?.routes?.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: 1 }], sections: sections.join(','), sections_url: location.pathname })
      });
      const res = await r.json();
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      d.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: cart.item_count, source: 'mollo-upsell', sections: res.sections, didError: !!res.status } });
      if (res.status) { btn.disabled = false; btn.classList.remove('is-busy'); btn.querySelector('span').textContent = 'Indisponible'; }
    } catch (err) {
      d.reject(err); btn.disabled = false; btn.classList.remove('is-busy');
    }
  };
}
if (!customElements.get('mollo-cart-upsell')) customElements.define('mollo-cart-upsell', MolloCartUpsell);

// Traduction des libellés Shopify restés en anglais dans la fenêtre Compte
const MO_FR = { 'Orders': 'Commandes', 'Profile': 'Profil', 'OR': 'OU', 'Sign out': 'Se déconnecter', 'Log out': 'Se déconnecter', 'Account': 'Compte', 'Settings': 'Paramètres' };
function moTranslate(root, depth) {
  if (!root || depth > 6) return;
  const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let n;
  while ((n = tw.nextNode())) {
    const t = n.textContent.trim();
    if (MO_FR[t]) n.textContent = n.textContent.replace(t, MO_FR[t]);
  }
  root.querySelectorAll('*').forEach((el) => { if (el.shadowRoot) moTranslate(el.shadowRoot, depth + 1); });
}
// Ne tourne que brièvement, après un clic sur l'icône Compte (pas de minuterie permanente)
function moRun() { document.querySelectorAll('shopify-account').forEach((a) => a.shadowRoot && moTranslate(a.shadowRoot, 0)); }
let moT = 0;
function moBurst() {
  const end = Date.now() + 5000;
  clearInterval(moT);
  moT = setInterval(() => { moRun(); if (Date.now() > end) clearInterval(moT); }, 150);
}
document.addEventListener('click', (e) => { if (e.composedPath().some((n) => n.tagName === 'SHOPIFY-ACCOUNT')) moBurst(); }, true);
document.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.composedPath().some((n) => n.tagName === 'SHOPIFY-ACCOUNT')) moBurst(); }, true);

// Flèche « Catalogue » de la fiche produit : revient à la collection d'origine (filtres et défilement conservés)
document.addEventListener('click', (e) => {
  const a = e.target.closest && e.target.closest('.mo-pdp__crumb a[href="/collections/tous-les-modeles"]');
  if (!a || !document.referrer) return;
  try {
    const r = new URL(document.referrer);
    if (r.host === location.host && r.pathname.indexOf('/collections/') === 0 && history.length > 1) { e.preventDefault(); history.back(); }
  } catch (err) {}
});

// Galerie fiche produit : les PNG opaques (vraies photos) passent en plein cadre, les détourés restent centrés
function moPhotos() {
  document.querySelectorAll('.mo-pdp__slide--cut img').forEach((im) => {
    if (im.dataset.al) return; im.dataset.al = '1';
    const go = () => {
      let u = im.currentSrc || im.src; if (!u) return;
      try { const x = new URL(u, location.href); x.searchParams.set('width', '48'); u = x.href; } catch (e) {}
      fetch(u, { mode: 'cors', credentials: 'omit' }).then((r) => r.blob()).then((b) => createImageBitmap(b)).then((bm) => {
        const c = document.createElement('canvas'); c.width = c.height = 24;
        const x = c.getContext('2d'); x.drawImage(bm, 0, 0, 24, 24);
        const d = x.getImageData(0, 0, 24, 24).data;
        const alpha = [0, 23, 552, 575, 11, 264].some((i) => d[i * 4 + 3] < 250);
        if (!alpha) im.closest('.mo-pdp__slide').classList.add('is-photo');
      }).catch(() => {});
    };
    go();
  });
}
moPhotos();
document.addEventListener('shopify:section:load', () => setTimeout(moPhotos, 50));

// Paiement express : Shop Pay masqué, on remonte PayPal pour combler l'emplacement vide
function moWallet() {
  document.querySelectorAll('shopify-accelerated-checkout-cart').forEach((a) => {
    if (!a.querySelector('shop-pay-wallet-button')) return;
    const pp = a.querySelector('shopify-paypal-button');
    if (!pp || !pp.offsetHeight) { a.style.marginTop = ''; return; }
    a.style.marginTop = '0px';
    const off = Math.round(pp.getBoundingClientRect().top - a.getBoundingClientRect().top);
    a.style.marginTop = off > 1 ? -off + 'px' : '';
    if (!a.dataset.moRo && 'ResizeObserver' in window) { a.dataset.moRo = '1'; new ResizeObserver(() => requestAnimationFrame(moWallet)).observe(a); }
  });
}
let moWn = 0;
const moWi = setInterval(() => { moWallet(); if (++moWn > 40) clearInterval(moWi); }, 400);
document.addEventListener('cart:update', () => setTimeout(moWallet, 300));
document.addEventListener('click', () => setTimeout(moWallet, 600), true);

// Galerie : les visuels verticaux (infographies) s'affichent en entier, centrés
function moTall() {
  document.querySelectorAll('.mo-pdp__slide img').forEach((im) => {
    const f = () => {
      const w = im.naturalWidth || +im.getAttribute('width'), h = im.naturalHeight || +im.getAttribute('height');
      if (w && h && h > w * 1.08) im.closest('.mo-pdp__slide').classList.add('is-tall');
    };
    f(); if (!im.complete) im.addEventListener('load', f, { once: true });
  });
}
moTall();
document.addEventListener('shopify:section:load', () => setTimeout(moTall, 50));

// Photos lifestyle (sans transparence) : plein cadre dans les cartes produit et le produit phare
function moFit(root) {
  (root || document).querySelectorAll('.card-gallery img, .mo-spot__main img, .mo-spot__thumbs img').forEach((im) => {
    const check = () => {
      let u = im.currentSrc || im.src; if (!u || im.dataset.fitSrc === u) return; im.dataset.fitSrc = u;
      try { const x = new URL(u, location.href); x.searchParams.set('width', '48'); x.searchParams.delete('height'); u = x.href; } catch (e) {}
      fetch(u, { mode: 'cors', credentials: 'omit' }).then((r) => r.blob()).then((b) => createImageBitmap(b)).then((bm) => {
        const c = document.createElement('canvas'); c.width = c.height = 24;
        const x = c.getContext('2d'); x.drawImage(bm, 0, 0, 24, 24);
        const d = x.getImageData(0, 0, 24, 24).data;
        const alpha = [0, 23, 552, 575, 11, 264].some((i) => d[i * 4 + 3] < 250);
        im.classList.toggle('mo-photo', !alpha);
        const box = im.closest('.mo-spot__main');
        if (box) box.style.aspectRatio = (!alpha && im.naturalWidth && im.naturalHeight) ? (im.naturalWidth + ' / ' + im.naturalHeight) : '';
      }).catch(() => {});
    };
    if (!im.dataset.fitBound) { im.dataset.fitBound = '1'; im.addEventListener('load', check); }
    if (im.complete && (im.currentSrc || im.src)) check();
  });
}
moFit();
document.addEventListener('shopify:section:load', () => setTimeout(moFit, 50));
document.addEventListener('load', (e) => { const t = e.target; if (t && t.tagName === 'IMG' && t.closest('.card-gallery, .mo-spot__main, .mo-spot__thumbs')) moFit(t.parentElement); }, true);
function moFrame() { document.querySelectorAll('.mo-pdp__track').forEach((tr) => { if (tr.dataset.moFrame) return; tr.dataset.moFrame = '1'; const apply = () => { const slides = tr.children; if (!slides.length) return; const i = Math.max(0, Math.min(slides.length - 1, Math.round(tr.scrollLeft / (tr.clientWidth || 1)))); const s = slides[i], im = s && s.querySelector('img'); const w = im && (im.naturalWidth || +im.getAttribute('width')), h = im && (im.naturalHeight || +im.getAttribute('height')); const tall = s && s.classList.contains('is-tall') && w && h; tr.style.aspectRatio = tall ? (w + ' / ' + h) : ''; tr.classList.toggle('is-fit', !!tall); if (tall) { const x = slides[i].offsetLeft; if (Math.abs(tr.scrollLeft - x) > 2) tr.scrollLeft = x; } }; let t = 0; tr.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(apply, 120); }, { passive: true }); window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(apply, 150); }); tr.querySelectorAll('img').forEach((im) => { if (!im.complete) im.addEventListener('load', () => setTimeout(apply, 50), { once: true }); }); setTimeout(apply, 300); }); } moFrame(); document.addEventListener('shopify:section:load', () => setTimeout(moFrame, 80));